export const DOTS_TYPE = {
  DEFAULT: 'default',
  SMALL: 'small'
};

export const POSITION_TYPES = {
  INSIDE: 'inside',
  OUTSIDE: 'outside'
};
